import React from "react";
import PropTypes from "prop-types";

const RtrToggle = ({ checked, dataHeapId, disabled, labelText, onChange }) => {
  const cursorClass = disabled ? "cursor-default" : "cursor-pointer";
  const backgroundColor = disabled ? "bg-lightGray" : "bg-darkerGray peer-checked:bg-wine";
  return (
    <label className={`inline-flex items-center tracking-normal ${cursorClass} mb-0`} data-heap-id={dataHeapId}>
      <input type="checkbox" checked={checked} disabled={disabled} onChange={onChange} className="sr-only peer" />
      <div
        className={`relative w-11 h-6 ${backgroundColor} rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all`}></div>
      <span className="normal-case text-sm mx-2">{labelText}</span>
    </label>
  );
};

RtrToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  dataHeapId: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  labelText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default RtrToggle;
